import dayjs from 'dayjs'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { getBodyForSavingJournal } from 'src/consumer/helpers/dailyPlayHelper'
import {
  makeQuoteFavorite,
  makeQuoteUnfavorite,
  saveJournal,
} from 'src/consumer/services/featureServices'
import { ModalProvider } from 'styled-react-modal'
import {
  AuthorNameText,
  FadingBackground,
  FavoriteIcon,
  HeaderContainer,
  ModalCloseButton,
  ModalInsideContainer,
  QuoteBackground,
  QuoteTextArea,
  ReflectionSubmitButton,
  ReflectionTimeAndDate,
  ReflectiveQuestionHeading,
  RuledTextArea,
  StyledQuestionModal,
} from './QuoteAndReflectionStyles'
import quoteIcon from 'src/assets/quote_icon.png'
import emptyHeart from 'src/assets/empty_heart.png'
import filledHeart from 'src/assets/filled_heart.png'
import closeIconPurple from 'src/assets/close_icon_purple.png'

export const QuoteComponent = (props) => {
  const { data, isFavorite, toggleFavorite } = props

  return (
    <QuoteBackground>
      <HeaderContainer>
        <img src={quoteIcon} alt="quoteicon" />
      </HeaderContainer>
      <QuoteTextArea>{`"${data?.msg}"`}</QuoteTextArea>
      <div className="d-flex align-items-center justify-content-between">
        <AuthorNameText>{data?.author}</AuthorNameText>
        {!isFavorite && (
          <FavoriteIcon
            src={emptyHeart}
            onClick={() => {
              toggleFavorite()
              makeQuoteFavorite(data?.id)
            }}
          />
        )}
        {isFavorite && (
          <FavoriteIcon
            src={filledHeart}
            onClick={() => {
              toggleFavorite()
              makeQuoteUnfavorite(data?.id)
            }}
          />
        )}
      </div>
    </QuoteBackground>
  )
}

export const ReflectiveQuestion = ({
  questionOpen,
  setIsQuestionOpen,
  questionData,
  toggleQuoteModal,
  callSource,
  callSourceId,
  showCongratulatoryMessage,
  afterSubmissionFunction = () => {},
  congratulatoryCardData,
  setCongratulatoryCardData,
  ...props
}) => {
  const [answerValue, setAnswerValue] = useState(questionData?.journalQusAns?.[0]?.answere || '')
  const [opacity, setOpacity] = useState(0)
  const [submitWaiting, setSubmitWaiting] = useState(false)
  const startingTime = dayjs()

  function toggleModal(e) {
    setOpacity(0)
    setIsQuestionOpen(!questionOpen)
  }

  function afterOpen() {
    setTimeout(() => {
      setOpacity(1)
    }, 100)
  }

  function beforeClose() {
    return new Promise((resolve) => {
      setOpacity(0)
      setTimeout(resolve, 300)
    })
  }

  async function handleSubmit() {
    let timeOnSubmit = dayjs()
    let duration = timeOnSubmit.diff(startingTime, 'milliseconds')
    setSubmitWaiting(true)

    const quesAns = [
      {
        qusId: questionData?.journalQusAns?.[0]?.qusId,
        question: questionData?.journalQusAns?.[0]?.question,
        subtext: questionData?.journalQusAns?.[0]?.subtext,
        answere: answerValue,
        answer: answerValue,
        hints: questionData?.journalQusAns?.[0]?.hints,
      },
    ]

    let body

    if (props?.edit === true) {
      let jetID = questionData?.id
      body = getBodyForSavingJournal(
        questionData?.journalId,
        quesAns,
        questionData?.journalType,
        startingTime,
        duration,
        jetID,
      )
    } else {
      body = getBodyForSavingJournal(
        questionData?.id,
        quesAns,
        questionData?.journalType,
        startingTime,
        duration,
      )
    }

    let response = await saveJournal(questionData?.id, body, callSource, callSourceId)

    if (response.status === 200) {
      if (props?.edit === true) {
        toggleModal()
        setSubmitWaiting(false)
      } else {
        setSubmitWaiting(false)
        showCongratulatoryMessage &&
          !!questionData?.coins &&
          setCongratulatoryCardData({
            showCard: true,
            data: {
              coins: questionData?.coins,
              completed: questionData?.completed,
              completedItemType: 'reflection',
              itemData: questionData,
            },
          })
        toggleQuoteModal()
        toggleModal()
      }
      await afterSubmissionFunction()
    }
  }

  return (
    <ModalProvider backgroundComponent={FadingBackground}>
      <StyledQuestionModal
        isOpen={questionOpen}
        afterOpen={afterOpen}
        beforeClose={beforeClose}
        onBackgroundClick={toggleModal}
        onEscapeKeydown={toggleModal}
        opacity={opacity}
        backgroundProps={{ opacity }}
      >
        <ModalInsideContainer>
          <ModalCloseButton src={closeIconPurple} onClick={toggleModal} />
          <ReflectionTimeAndDate>{startingTime?.format('h:mm a, DD MMM')}</ReflectionTimeAndDate>
          <ReflectiveQuestionHeading>
            {questionData?.journalQusAns?.[0]?.question}
          </ReflectiveQuestionHeading>
          <RuledTextArea
            autoFocus
            placeholder="Your thoughts here..."
            value={answerValue}
            onChange={(e) => setAnswerValue(e.target.value)}
          ></RuledTextArea>
        </ModalInsideContainer>
        <ReflectionSubmitButton disabled={answerValue === ''} onClick={handleSubmit}>
          {submitWaiting ? <Spinner animation="border" variant="light" size="md" /> : 'Submit'}
        </ReflectionSubmitButton>
      </StyledQuestionModal>
    </ModalProvider>
  )
}
